/**
 * `IconAssetsProvider`: the pictures `Icon` draws that a bundler must load (DESIGN_SYSTEM.md §5.1, QD9), handed
 * over by each app's shell, the way My Orders' shells hand their images to `OrdersAssets`.
 *
 * - `sprite`: v2's ONE sprite sheet, `@rista/ui/library/icons/sheet/rista-sprite-3x.png` (generated from web's
 *   SVG, so both apps draw web's art). The shell loads it (webpack gives a URL, Metro an asset id) so the node
 *   test runner, which loads no binary file, never has to.
 * - `images`: fixed pictures by key (a channel's logo, a payment mode's), for `Icon`'s `image` kind.
 *
 * With no provider (a test, an isolated render) a sprite or image glyph draws an empty box of its size, so
 * layout holds and every word still shows.
 */
import React, { createContext, useContext } from "react";
import type { ImageSourcePropType } from "react-native";

export interface IconAssets {
  sprite?: ImageSourcePropType;
  images?: Readonly<Record<string, ImageSourcePropType>>;
}

const NONE: IconAssets = {};
const Context = createContext<IconAssets>(NONE);

export function IconAssetsProvider({ value, children }: { value: IconAssets; children: React.ReactNode }) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export const useIconAssets = (): IconAssets => useContext(Context);
